import { render, staticRenderFns } from "./needBaseInfo.vue?vue&type=template&id=458a53aa&scoped=true&"
import script from "./needBaseInfo.vue?vue&type=script&lang=js&"
export * from "./needBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./needBaseInfo.vue?vue&type=style&index=0&id=458a53aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a53aa",
  null
  
)

export default component.exports